import { all, call } from 'typed-redux-saga/macro';

import { withErrorHandling } from 'Lib/sagaHelpers';

import { loadAsyncBundle } from '../asyncSaga';

export const loadAsyncFeatures = withErrorHandling(
  function* _loadAsyncFeatures(action) {
    const features = action.payload || [];
    yield* all(features.map((feature: string) => call(loadAsyncBundle, feature)));
  },
  {
    name: 'loadAsyncFeatures',
  }
);
